import logo from "../../Images/brand/logo.png"
import compoundImg from "../../Images/virtuous_database_search.png"
import plantImg from "../../Images/details/3.png"

import { Link } from "react-router-dom";


function Silver(){
    return <div className="flex flex-col h-full antialiased bg-neutral-800"> 
    {/* Top Bar */}
    <header className="sticky top-0 z-50 bg-white md:px-24 drop-shadow-md">
      <div className="flex flex-col items-center justify-between gap-4 p-5 md:flex-row">
        <a href="/"><img className="w-40" src={logo} alt="Virtuous LOGO" /></a>
        <a href="/" className="flex items-center gap-4 cta cta-primary">
          <p>All tools</p>
          <i className="ph-caret-right"></i>
        </a>
      </div>
    </header>
     
        
    
        <main
            className="container relative flex flex-col flex-auto gap-8 p-8 mx-auto my-8 md:p-10 card">
            {/*Action Top*/}
            <div className="flex items-center gap-4">
                <img src={compoundImg} alt="Virtuous Compounds"
                    className="w-40 h-40 p-4 bg-gray-100 rounded-full" />
                <div>
                    <h1 className="font-bold uppercase ">Virtuous Database Search</h1>
                    <p className="text-gray-500">Dynamic and interactive exploration of the FooDB (<a href="https://foodb.ca"
                            className="link" target="_blank">foodb.ca</a>)</p>
                </div>
            </div>
            
            <div className="flex flex-col gap-4 md:flex-row md:justify-between">
                {/*sx*/}
                <div className="flex items-center justify-center gap-4 p-2 bg-gray-100 rounded-xl">
                    <h1 className="text-xl font-bold uppercase">Silver linden</h1>
                    <div className="flex items-center justify-center gap-2 p-2 bg-white rounded-xl">ID<span
                            className="font-bold ">03</span></div>
                </div>
    
                {/*sx*/}
                <Link to="/foods" className="flex items-center gap-4 cta cta-secondary">
                    <p>Foods list</p>
                    <i className="ph-caret-right"></i>
                </Link>
                
            </div>
    
            {/* info */}
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                
                
                <div className="p-4 bg-gray-100 rounded-xl">
                    <img className="w-full overflow-hidden rounded-xl" src={plantImg} alt="Angelica keiskei" />
                </div>
                <div className="p-4 bg-gray-100 rounded-xl ">
                    <h3 className="mb-3 font-bold">Food description</h3>
                    Tilia tomentosa (Silver Lime in the UK and Silver Linden in the US) is a species of Tilia native to southeastern Europe
                    and southwestern Asia, from Hungary and the Balkans east to western Turkey, occurring at moderate altitudes. It is a
                    deciduous tree growing to 20–35 m tall, with a trunk up to 2 m diameter. The leaves are alternately arranged, rounded to
                    triangular-ovate, 4–13 cm long and broad with a 2.5–4 cm petiole, green and mostly hairless above, densely white
                    tomentose with white hairs below, and with a coarsely toothed margin. The flowers are pale yellow, hermaphrodite,
                    produced in cymes of three to ten in mid to late summer with a pale green subtending leafy bract; they have a strong
                    scent and are pollinated by honeybees. The nectar however contains sugars which cannot be digested by other bees, to
                    whom the tree is somewhat toxic. The fruit is a dry nut-like drupe 8–10 mm long, downy, and slightly ribbed.
                </div>
                <div className="grid grid-cols-2 gap-4 p-4 bg-gray-100 md:col-span-2 rounded-xl lg:col-span-1">
                    <div className="items-center justify-center w-full p-4 text-lg bg-white rounded-xl">name <br /><span
                            className="text-xl font-bold">Silver linden</span></div>
                    <div className="items-center justify-center w-full p-4 text-lg bg-white rounded-xl">Scientific name <br /><span
                            className="text-xl font-bold">Tilia argentea</span></div>
                    <div className="items-center justify-center w-full p-4 text-lg bg-white rounded-xl">Food group <br /><span
                            className="text-xl font-bold">Herbs and Spices</span></div>
                    <div className="items-center justify-center w-full p-4 text-lg bg-white rounded-xl">Food subgroup<br /><span
                            className="text-xl font-bold">Herbs</span></div>
                </div>
                
            </div>
    
    
            {/*Compounds*/}
            <div class="grid gap-4 p-4 bg-gray-100 rounded-3xl ">
            <h3 class="font-bold">Compounds</h3>
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table class="w-full text-sm text-left text-primary-100 dark:text-primary-100">
                    <thead class="text-xs text-white uppercase bg-primary-600 dark:text-white">
                        <tr>
                            <th scope="col" class="px-6 py-3"> Name </th>
                            <th scope="col" class="px-6 py-3"> SMILES </th>
                            <th scope="col" class="px-6 py-3"> Content </th>
                            <th scope="col" class="px-6 py-3 text-right"></th>
                        </tr>
                    </thead>
                    <tbody class="text-sm text-white">
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">3,4-Dihydroxyphenylacetic acid </span><br />C8H8O4 </td>
                            <td class="px-6 py-4"> OC(=O)CC1=CC(O)=C(O)C=C1 </td>
                            <td class="px-6 py-4 whitespace-nowrap"> </td>
                            
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"OC(=O)CC1=CC(O)=C(O)C=C1"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">Moupinamide </span><br />C18H19NO4 </td>
                            <td class="px-6 py-4"> COC1=CC(\C=C\C(=O)NCCC2=CC=C(O)C=C2)=CC=C1O </td>
                            <td class="px-6 py-4 whitespace-nowrap"> </td>
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"COC1=CC(\C=C\C(=O)NCCC2=CC=C(O)C=C2)=CC=C1O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">Tyramine </span><br />C8H11NO </td>
                            <td class="px-6 py-4"> NCCC1=CC=C(O)C=C1 </td>
                            <td class="px-6 py-4 whitespace-nowrap"> </td>
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"NCCC1=CC=C(O)C=C1"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">2'-Hydroxydaidzein </span><br />C15H10O5 </td>
                            <td class="px-6 py-4"> OC1=CC(O)=C(C=C1)C1=COC2=C(C=CC(O)=C2)C1=O </td>
                            <td class="px-6 py-4"></td>
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"OC1=CC(O)=C(C=C1)C1=COC2=C(C=CC(O)=C2)C1=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">L-Tyrosine </span><br />C9H11NO3 </td>
                            <td class="px-6 py-4"> NC(CC1=CC=C(O)C=C1)C(O)=O </td>
                            <td class="px-6 py-4 whitespace-nowrap"> </td>
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"NC(CC1=CC=C(O)C=C1)C(O)=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">Sinapine </span><br />C16H24NO5 </td>
                            <td class="px-6 py-4"> COC1=CC(\C=C/C(=O)OCC[N+](C)(C)C)=CC(OC)=C1O </td>
                            <td class="px-6 py-4 whitespace-nowrap"></td>
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"COC1=CC(\C=C/C(=O)OCC[N+](C)(C)C)=CC(OC)=C1O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">xi-1-(3,4-Dihydroxyphenyl)-1,2-ethanediol </span><br />C8H10O4 </td>
                            <td class="px-6 py-4"> OCC(O)C1=CC(O)=C(O)C=C1 </td>
                            <td class="px-6 py-4 whitespace-nowrap"></td>
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"OCC(O)C1=CC(O)=C(O)C=C1"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">L-Saccharopine </span><br />C11H20N2O6 </td>
                            <td class="px-6 py-4"> NC(CCCCNC(CCC(O)=O)C(O)=O)C(O)=O </td>
                            <td class="px-6 py-4 whitespace-nowrap"></td>
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"NC(CCCCNC(CCC(O)=O)C(O)=O)C(O)=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">L-Valine </span><br />C5H11NO2 </td>
                            <td class="px-6 py-4"> CC(C)C(N)C(O)=O </td>
                            <td class="px-6 py-4 whitespace-nowrap"></td>
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"CC(C)C(N)C(O)=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr class="border-b bg-primary-500 border-primary-400">
                            <td class="px-6 py-4 whitespace-nowrap "> <span class="font-bold">L-Lysine </span><br />C6H14N2O2 </td>
                            <td class="px-6 py-4"> NCCCC[C@H](N)C(O)=O </td>
                            <td class="px-6 py-4 whitespace-nowrap"></td>
                            <td class="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"NCCCC[C@H](N)C(O)=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
   
                    </tbody>
                </table>
            </div>
        </div>
            {/*Action bottom*/}
            <div className="mx-auto">
                <nav aria-label="Page navigation example">
                    <ul className="inline-flex -space-x-px">
                        <li>
                            <a href="#"
                                className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700">Previous</a>
                        </li>
                        <li>
                            <a href="#" aria-current="page"
                                className="px-3 py-2 leading-tight border border-gray-300 text-primary-600 bg-primary-50 hover:bg-gray-100 hover:text-gray-700">1</a>
                        </li>
                        <li>
                            <a href="#"
                                className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">2</a>
                        </li>
                        <li>
                            <a href="#" 
                                className="px-3 py-2 text-gray-500 bg-white border border-gray-300 hover:bg-primary-100 hover:text-primary-700">3</a>
                        </li>
                        <li>
                            <a href="#"
                                className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700">4</a>
                        </li>
                        <li>
                            <a href="#"
                                className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700">5</a>
                        </li>
                        <li>
                            <a href="#"
                                className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700">Next</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </main> 

     
    </div>
}

export default Silver;